module.exports = __webpack_public_path__ + "static/assets/4838eb6833f72e35dff3df69f5861eec.png";